<template>
  <q-select
    v-model="selectCategory"
    :options="options"
    outlined
    dense
    clearable
    emit-value
    map-options
    :disable="props.disabled"
    :loading="isLoading"
    style="background: var(--q-white); padding: 0"
    :rules="props.isValidate ? [(val) => !!val || $t('validation.required')] : undefined"
  >
    <template #no-option>
      <q-item>
        <q-item-section class="text-grey">該当するカテゴリーはありません</q-item-section>
      </q-item>
    </template>
    <template #default>
      <div v-if="!selectCategory" style="position: absolute; top: 10px">
        <span class="text-dark">選択してください</span>
      </div>
    </template>
  </q-select>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface Props {
  category: string;
  // validate有無
  isValidate?: boolean;
  disabled?: boolean;
}

interface CategorySelect {
  label: string;
  value: string;
}

const props = withDefaults(defineProps<Props>(), {
  isValidate: false,
  disabled: false,
});
const router = useRouter();
const emit = defineEmits(['selectCategory']);

// カテゴリープルダウン
const options = ref<CategorySelect[]>([]);
// Loading
const isLoading = ref(false);

// カテゴリー選択値
const selectCategory = computed({
  get: () => props.category,
  set: (value) => {
    emit('selectCategory', value || '');
  },
});

/**
 * カテゴリーリスト取得
 */
const getCategory = () => {
  // Loading Start
  isLoading.value = true;

  axios
    .post('/categories')
    .then((res) => {
      const { common, categoryOptions } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          options.value = categoryOptions;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      isLoading.value = false;
    });
};

/**
 * 初期表示処理
 */
getCategory();
</script>
